export default __webpack_public_path__ + "static/media/erasmus.7e62d705.png";